import { render, staticRenderFns } from "./WarningCallout.vue?vue&type=template&id=18cafe12&scoped=true&"
import script from "./WarningCallout.vue?vue&type=script&lang=js&"
export * from "./WarningCallout.vue?vue&type=script&lang=js&"
import style0 from "./WarningCallout.vue?vue&type=style&index=0&id=18cafe12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cafe12",
  null
  
)

export default component.exports